<template lang="pug"
src='./glazing.pug'>

</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import saveBtn from '@/common/components/saveBtn.vue'

export default {
	name: 'glazing',
	props: ['project', 'control', 'readonly', 'findControlTextByKey'],
	components: { saveBtn },
	data () {
		return {
			fenest: {
				Windows: 'Windows',
				OperableWindows: 'Operable Windows',
				FixedWindows: 'Fixed Windows',
				SlidingGlassDoors: 'Sliding Glass Doors',
				FrenchDoors: 'French Doors',
				Skylights: 'Skylights'
			},
			standardFenest: [
				{
					type: 'Windows',
					val1: 'VY',		// Frame Type or Maximum U-Factor if specific fenestration
					val2: 'Low-E3.Sun'	// Glazing or Maximum Solar Heat Gain Coefficient (SHGC) if specific fenestration
				},
				{
					type: 'SlidingGlassDoors',
					val1: 'AL',		// Frame Type or Maximum U-Factor if specific fenestration
					val2: 'CLEAR.DUAL'	// Glazing or Maximum Solar Heat Gain Coefficient (SHGC) if specific fenestration
				},
				{
					type: 'FrenchDoors',
					val1: 'FG',		// Frame Type or Maximum U-Factor if specific fenestration
					val2: 'Low-E3.Sun'	// Glazing or Maximum Solar Heat Gain Coefficient (SHGC) if specific fenestration
				},
				{
					type: 'Skylights',
					val1: 'AL',		// Frame Type or Maximum U-Factor if specific fenestration
					val2: 'Low-E3.Sun'	// Glazing or Maximum Solar Heat Gain Coefficient (SHGC) if specific fenestration
				}
			],
			specificFenest: [
				{
					type: 'OperableWindows',
					val1: 0.0,
					val2: 0.0
				},
				{
					type: 'FixedWindows',
					val1: 0.0,
					val2: 0.0
				},
				{
					type: 'SlidingGlassDoors',
					val1: 0.0,
					val2: 0.0
				},
				{
					type: 'FrenchDoors',
					val1: 0.0,
					val2: 0.0
				},
				{
					type: 'Skylights',
					val1: 0.0,
					val2: 0.0
				}
			],
			glassDefault: {
				orient: 0,
				sashType: 'FR1, FRENCH',
				unitWidth: 0.0,
				unitHeight: 0.0,
				OH: true,
				OHHeight: 0.0,
				OHLength: 0.0,
				sideFin: false
			},
			sideFinVal: {
				leftHDeep: 0.0,
				heightAbvWinHead: 0.0,
				distLeftWinEdge: 0.0,
				rightHDeep: 0.0,
				heightAbvWinHead2: 0.0,
				distRightWinEdge: 0.0
			}
		}
	},
	mounted () {
		this.initEmptyFieldZero()
		this.calculateOverhangHeight()
	},
	methods: {
		initEmptyFieldZero () {
			let tOL = this.project.glazing.overhangLength
			let tRS = this.project.floorsRoofs.typRoofSlope
			if (tOL === undefined || !tOL || tOL < 0) { this.project.glazing.overhangLength = 0 }
			if (tRS === undefined || !tRS || tRS < 0) { this.project.floorsRoofs.typRoofSlope = 0 }
		},
		deleteGlass (index) {
			this.project.glazing.glass.splice(index, 1)
		},
		changeFenest (value) {
			// console.log('Change Fenestration', value)
			switch (value) {
			case 'STANDARD':
				this.project.glazing.fenestrationType = _.clone(this.standardFenest)
				break
			case 'SPECIFIC':
				this.project.glazing.fenestrationType = _.clone(this.specificFenest)
				break
			}
		},
		changeSideFin (newVal, index) {
			if (newVal && _.isNil(this.project.glazing.glass[index].sideFinVal)) {
				this.project.glazing.glass[index].sideFinVal = _.clone(this.sideFinVal)
			}
		},
		addGlass () {
			this.project.glazing.glass.push(_.clone(this.glassDefault))
		},
		calculateOverhangHeight () {
			// Update defaults
			this.glassDefault.OHHeight = parseFloat(Vue.e24.projectService.calculateGlazingOverhangHeight(this.project))
			this.glassDefault.OHLength = this.project.glazing.overhangLength
			// Update every glass
			this.updateGlazings()
		},
		updateGlazings () {
			// Update glazing surfaces based on calculated overhang height
			this.project.glazing.glass.forEach((glazingSurface, index) => {
				this.updateGlazing(index)
			})
		},
		updateGlazing (index) {
			let glazing = this.project.glazing
			if (glazing.glass[index].OH) { // if Typcl OH
				this.project.glazing.glass[index].OHHeight = this.glassDefault.OHHeight
				this.project.glazing.glass[index].OHLength = this.project.glazing.overhangLength
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/app/take-off-tool/tabs-components/glazing.vue